import { Box, Flex, Icon } from "@chakra-ui/react"
import { FramerBox } from "@components/animations/FramerBox"
import { AnimateHeroImageProps, HeroProps } from "@definitions/types"
import svgPlayIcon from "@public/svg/hero/play-icon.svg"
import { AnimatePresence } from "framer-motion"
import Image from "next/image"

const AnimateHeroImage = ({ children, id, delay }: AnimateHeroImageProps) => {
  return (
    <AnimatePresence>
      <FramerBox
        key={id}
        initial={{ opacity: 0, x: 0, y: 0, scale: 0 }}
        whileInView={{
          opacity: 1,
          scale: 1,
          x: 0,
          y: 0,
        }}
        exit={{ opacity: 0, x: 0, y: 0, scale: 0 }}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        transition={{
          delay: delay ? delay : 0,
          duration: 0.2,
          ease: "easeInOut",
        }}
      >
        {children}
      </FramerBox>
    </AnimatePresence>
  )
}

export default function Hero(props: HeroProps) {
  return (
    <Flex
      direction={"row"}
      display={{ base: "none", lg: "flex" }}
      justifyContent={"center"}
      mt={6}
    >
      <Flex
        direction={"column"}
        alignItems={"flex-end"}
        m={4}
      >
        <Flex
          width={130}
          height={130}
          borderRadius={"full"}
          backgroundColor={"blackAlpha.800"}
          overflow={"hidden"}
          justifyContent={"center"}
          alignItems={"center"}
          mb={4}
        >
          <AnimateHeroImage
            id={"icon-1"}
            delay={0.1}
          >
            <Icon
              as={props.iconOne}
              color={"white"}
              w={16}
              h={16}
            />
          </AnimateHeroImage>
        </Flex>
        <AnimateHeroImage
          id={"image-1"}
          delay={0.15}
        >
          <Image
            src={props.imageOne}
            loader={({ src }) => src}
            width={310}
            height={470}
            alt={props.alt}
            placeholder={"blur"}
            priority
            style={{ borderRadius: 20 }}
          />
        </AnimateHeroImage>
      </Flex>
      <Flex
        direction={"column"}
        alignItems={"center"}
        m={4}
      >
        <AnimateHeroImage
          id={"image-2"}
          delay={0.2}
        >
          <Image
            src={props.imageTwo}
            loader={({ src }) => src}
            width={310}
            height={470}
            alt={props.alt}
            placeholder={"blur"}
            priority
            style={{ borderRadius: 20 }}
          />
        </AnimateHeroImage>
        <Flex
          mt={10}
          width={"full"}
          background={"blackAlpha.100"}
          borderRadius={20}
          justifyContent={"center"}
          alignItems={"center"}
          height={{ lg: 350, xl: 470 }}
        >
          <AnimateHeroImage
            id={"icon-2"}
            delay={0.25}
          >
            <Icon
              as={props.iconTwo}
              color={"brand.secondary"}
              w={150}
              h={150}
            />
          </AnimateHeroImage>
        </Flex>
      </Flex>
      <Flex
        direction={"column"}
        alignItems={"center"}
        m={4}
      >
        <Flex
          width={"full"}
          height={{ lg: 350, xl: 470 }}
          mb={10}
          justifyContent={"flex-end"}
          flexDirection={"column"}
        >
          <Box position={"relative"}>
            <AnimateHeroImage
              id={"icon-4"}
              delay={0.3}
            >
              <Icon
                as={props.iconFour ? props.iconFour : svgPlayIcon}
                color={"brand.secondary"}
                w={16}
                h={16}
                position={"absolute"}
                top={0}
                right={0}
              />
            </AnimateHeroImage>
            <Box
              borderRadius={"full"}
              overflow={"hidden"}
              position={"relative"}
            >
              <AnimateHeroImage
                id={"image-3"}
                delay={0.35}
              >
                <Image
                  src={props.imageThree}
                  loader={({ src }) => src}
                  width={310}
                  height={310}
                  alt={props.alt}
                  placeholder={"blur"}
                  priority
                />
              </AnimateHeroImage>
            </Box>
          </Box>
        </Flex>
        <AnimateHeroImage
          id={"image-4"}
          delay={0.4}
        >
          <Image
            src={props.imageFour}
            loader={({ src }) => src}
            width={310}
            height={354}
            alt={props.alt}
            placeholder={"blur"}
            priority
            style={{ borderRadius: 20 }}
          />
        </AnimateHeroImage>
      </Flex>
      <Flex
        direction={"column"}
        alignItems={"flex-start"}
        m={4}
      >
        <Flex
          mb={10}
          p={10}
          width={"full"}
          background={"blackAlpha.100"}
          borderRadius={20}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <AnimateHeroImage
            id={"image-5"}
            delay={0.45}
          >
            <Image
              src={props.imageFive}
              loader={({ src }) => src}
              width={200}
              height={410}
              alt={props.alt}
              placeholder={"blur"}
              priority
            />
          </AnimateHeroImage>
        </Flex>
        <Flex
          width={130}
          height={130}
          borderRadius={"full"}
          backgroundColor={"brand.primary"}
          overflow={"hidden"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <AnimateHeroImage
            id={"icon-3"}
            delay={0.5}
          >
            <Icon
              as={props.iconThree}
              color={"white"}
              w={16}
              h={16}
            />
          </AnimateHeroImage>
        </Flex>
      </Flex>
    </Flex>
  )
}
